import {AnyAction} from 'redux';
import {SET_REMITTANCE, CLEAN_REMITTANCE} from '../actionTypes';

export interface RemittanceState {
  name: string;
  countryCode: string;
  mobilePhone: string;
  description: string;
  amount: string|number;
  emojiURL: string;
  codeRemittance: string|number;
}

const initialState: RemittanceState = {
  name: '',
  countryCode: '',
  mobilePhone: '',
  description: '',
  amount: '',
  emojiURL: '',
  codeRemittance: '',
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_REMITTANCE:
      return {
        ...state,
        ...(action.payload || {}),
      };
    case CLEAN_REMITTANCE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
